import { useTranslation } from "react-i18next";
import Button from "../../../components/buttons/button";
import { useState } from "react";
import Popup from "../../../components/popups/popup";
import Paginate from "../../../components/pagination/paginate";
import SearchSelect from "../../../components/select/searchSelect";
import { useOptions } from "../../../components/hooks/useOptionsHook";
import { FaChevronLeft } from "react-icons/fa";
import { RiSettings4Line } from "react-icons/ri";
import SearchVacations from "./searchVacations";
import VacationsTable from "./vacationsTable";
import LeaveSetup from "./leaveSetup";
import LeaveRequestDetails from "./leaveRequestDetails";
import { useNavigate } from "react-router-dom";

const Vacations = () => {
  const { t } = useTranslation();
  const [openSetup, setOpenSetUP] = useState(false);
  const [selected, setSelected] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const data = { last_page: 10 };
  const { paginationOptions } = useOptions();
  const navigate = useNavigate();
  return (
    <main>
      <div className="flex flex-wrap items-center justify-between md:flex-nowrap">
        <div className="flex items-center gap-2 my-4">
          <h1
            onClick={() => navigate("/employees")}
            className="text-lg font-bold capitalize cursor-pointer md:text-2xl text-primary"
          >
            {t("employees-1")}
          </h1>
          <FaChevronLeft className="ltr:rotate-180" />
          <p className="font-bold capitalize">{t("vacations")}</p>
        </div>
        <Button
          onClick={() => setOpenSetUP(true)}
          className={"bg-primary text-black"}
          type={"button"}
        >
          <RiSettings4Line size={24} />
          {t("leavePolicySetup")}
        </Button>
      </div>
      <article className="mainLinear grid p-4 rounded-[20px] mt-8">
        <SearchVacations t={t} />
        <VacationsTable t={t} setSelected={setSelected} setOpenEdit={setOpenEdit} />
      </article>
      <div className="flex items-center gap-2">
        <Paginate data={data} />
        <div>
          <SearchSelect
            options={paginationOptions}
            onChange={(e) => {
              alert("now paginating " + e.value);
            }}
            name={"paginate"}
            placeholder={t("show 10")}
          />
        </div>
      </div>
      <Popup open={openSetup} setOpen={setOpenSetUP} header={t("leavePolicySetup")}>
        <LeaveSetup t={t} />
      </Popup>

      <Popup open={openEdit} setOpen={setOpenEdit} header={t("leaveRequestDetails")}>
        <LeaveRequestDetails t={t} selected={selected} setOpen={setOpenEdit} />
      </Popup>
    </main>
  );
};

export default Vacations;
